import { camelCase as lodashCamelCase } from 'lodash'

export const camelCase = (field: string) => {
  return field
    .split('.')
    .map(part => lodashCamelCase(part))
    .join('.')
}

const UK_POSTAL_CODE_MIN_LENGTH = 5
const UK_POSTAL_CODE_SPLIT_INDEX = -3

export const sanitizePostalCode = ({
  postalCode,
  countryCode,
}: {
  postalCode: string | undefined
  countryCode: string | undefined
}) => {
  if (countryCode !== 'GB') return postalCode || ''

  const postalCodeWithoutSpaces = postalCode?.replace(/\s/g, '').toUpperCase() || ''

  if (postalCodeWithoutSpaces.length < UK_POSTAL_CODE_MIN_LENGTH) {
    return postalCodeWithoutSpaces
  }

  return [
    postalCodeWithoutSpaces.slice(0, UK_POSTAL_CODE_SPLIT_INDEX),
    postalCodeWithoutSpaces.slice(UK_POSTAL_CODE_SPLIT_INDEX),
  ].join(' ')
}
